// TODO revise
import React from "react";
import * as Yup from "yup";
import { Input } from "antd";

import i18n from "../../../../../i18n";
import { Field, FormConfig } from "../../../../controls/FormikForm";
import Button from "../../../../Button";

import styled from "styled-components/macro";

const Row = styled.div`
  display: flex;
`;

const Column = styled.div`
  flex: 1;

  & + & {
    margin-left: 24px;
  }
`;

const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
`;

const validationSchema = Yup.object().shape({
  message: Yup.string()
    .trim()
    .required(i18n.t("form:emptyFieldValidation"))
});

const MessageForm = ({ t, onSubmit, onClose, initialValue, ...props }) => {
  function handleSubmit(values) {
    onSubmit(values.message);
    onClose();
  }

  return (
    <FormConfig
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      initialValues={{ message: initialValue }}
    >
      {({ isValid, handleSubmit }) => (
        <form
          data-test="messageForm"
          onSubmit={event => {
            event.stopPropagation();
            handleSubmit(event);
          }}
        >
          <Row>
            <Column>
              <Field
                autoFocus
                name="message"
                label={t("opportunity:process.stepTypes.chatbot.tree.message")}
              >
                <Input.TextArea rows={4} />
              </Field>
            </Column>
          </Row>
          <Footer>
            <Button
              style={{ marginRight: 12 }}
              htmlType="button"
              type="quaternary"
              onClick={onClose}
            >
              {t("global:cancel")}
            </Button>
            <Button htmlType="submit" type="primary" disabled={!isValid}>
              {t("global:save")}
            </Button>
          </Footer>
        </form>
      )}
    </FormConfig>
  );
};

export default MessageForm;
